
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const OmOssPage = lazy(() => import('../pages/om-oss/page'));
const TjenesterPage = lazy(() => import('../pages/tjenester/page'));
const AktiviteterPage = lazy(() => import('../pages/aktiviteter/page'));
const KontaktPage = lazy(() => import('../pages/kontakt/page'));
const NyhetsbrevPage = lazy(() => import('../pages/nyhetsbrev/page'));
const PameldingKonferansePage = lazy(() => import('../pages/pamelding-konferanse/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Admin-siden er skjult fra offentlig routing
// Den er kun tilgjengelig via direkte URL under redigering

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/om-oss',
    element: <OmOssPage />,
  },
  {
    path: '/tjenester',
    element: <TjenesterPage />,
  },
  {
    path: '/aktiviteter',
    element: <AktiviteterPage />,
  },
  {
    path: '/kontakt',
    element: <KontaktPage />,
  },
  {
    path: '/nyhetsbrev',
    element: <NyhetsbrevPage />,
  },
  {
    path: '/pamelding-konferanse',
    element: <PameldingKonferansePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;